module.exports = __webpack_public_path__ + "static/media/bryne-custom-joinery.27c30281.png";